/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business CQRS データ整合性チェック API クライアント。サマリ取得・除外設定の作成/削除・ステータス管理・アクションログを提供する。
 * @graph-connects /data-integrity/summary [calls] 整合性サマリ取得
 * @graph-connects /data-integrity/exclusions [calls] 除外設定 作成/削除
 * @graph-connects /data-integrity/findings [calls] ステータス更新
 * @graph-connects /data-integrity/action-logs [calls] アクションログ取得
 */

import { request } from './api.js';
import type {
  IntegritySummaryResponse,
  ExclusionInput,
  ExclusionMutationResponse,
  StatusUpdateInput,
  StatusUpdateResponse,
  ActionLogListResponse,
} from '../types/data-integrity.js';

/** @graph-connects none */
export const dataIntegrityApi = {
  getSummary: (): Promise<IntegritySummaryResponse> =>
    request<IntegritySummaryResponse>('/data-integrity/summary'),
  createExclusion: (input: ExclusionInput): Promise<ExclusionMutationResponse> =>
    request<ExclusionMutationResponse>('/data-integrity/exclusions', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  removeExclusion: (id: string): Promise<{ deleted: boolean }> =>
    request<{ deleted: boolean }>(`/data-integrity/exclusions/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    }),
  updateFindingStatus: (
    findingId: string,
    input: StatusUpdateInput,
  ): Promise<StatusUpdateResponse> =>
    request<StatusUpdateResponse>(
      `/data-integrity/findings/${encodeURIComponent(findingId)}/status`,
      {
        method: 'PUT',
        body: JSON.stringify(input),
      },
    ),
  getActionLogs: (findingId?: string, limit?: number): Promise<ActionLogListResponse> => {
    const params = new URLSearchParams();
    if (findingId) params.set('findingId', findingId);
    if (limit) params.set('limit', String(limit));
    const qs = params.toString();
    return request<ActionLogListResponse>(`/data-integrity/action-logs${qs ? `?${qs}` : ''}`);
  },
};
